<template>
  <div v-if="!showDefault && $store.state.currentUser && $store.state.currentUser.user" class="avatar avatar-sm profile-cover-avatar">
    <img class="avatar-img" :src="avatarURL" alt="Profile Image">
  </div>
  <div v-else class="is-flex-desktop is-vcentered">
    <img v-if="showDefault" class="avatar-img" src="@/ui/assets/img/user-generic.png" alt="Profile Image">
  </div>
</template>
<script>
import { avatar } from '@/application/services/api-clients/avatar';

export default {
  name: 'AvatarShow',
  props: {
    showDefault: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    avatarURL() {
      if (this.$store.state.currentUser && this.$store.state.currentUser.user) {
        return `${avatar.URL(this.$store.state.currentUser.user._id)}?time=${this.$store.getters.timeAvatar}`;
      }
      return null;
    }
  }
};
</script>
